import { getProductos, createProducto, updateProducto, deleteProducto } from '../models/productoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchProductos(page, perPage) {
  try {
    const response = await getProductos(page, perPage);
    return {
      producto: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching productos:", error);
    Swal.fire('Error', 'No se pudieron cargar los productos', 'error');
    return null;
  }
}

export async function saveProducto(producto, currentProductoId) {
  try {
    if (currentProductoId) {
      await updateProducto(currentProductoId, producto);
      toasts.add({
        title: 'Éxito',
        description: 'Producto guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createProducto(producto);
      toasts.add({
        title: 'Éxito',
        description: 'Producto creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving producto:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el producto',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeProducto(id) {
  try {
    await deleteProducto(id);
    toasts.add({
      title: 'Éxito',
      description: 'Producto eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting producto:", error);
    Swal.fire('Error', 'No se pudo eliminar el producto', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'producto'
export function subscribeToProductos(searchQuery, handleSearch) {
  pb.collection('producto').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromProductos() {
  pb.collection('producto').unsubscribe('*');
}

export async function searchProductos(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('producto').getList(page, perPage, {
      filter: `descripcion ~ "${query}"`, // Búsqueda por el campo 'descripcion'
    });
    return {
      producto: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching productos:", error);
    Swal.fire('Error', 'No se pudieron buscar los productos', 'error');
    return null;
  }
}
